import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

import StarRating from "vue-star-rating";

export default {
  name: "sessions",
  components: {
    StarRating
  },
  props: [],
  data() {
    return {
      desc: "Manual Description",
      descriptions: [
        { value: "", text: "Manual Description" },
        "You didn't came...",
        "You didn't came... and I knew :)",
        "You were Late!",
        "Fantastic Day"
      ],
      filter: {
        group: null,
        student: null
      },
      path: {},
      groups: ["A", "B", "C", "D"],
      selectedGroup: null,

      points: [],
      user: {},
      selectedItem: "",
      fields: [
        // {
        //   key: "user.group",
        //   label: "Group"
        // },
        {
          key: "user",
          label: "Student"
        },
        {
          key: "assist",
          label: "Assistance"
        },
        {
          key: "training",
          label: "Training"
        },
        {
          key: "points",
          label: "Points"
        },
        {
          key: "desc",
          label: "Description"
        }
      ]
    };
  },
  computed: {
    paths() {
      return this.$store.getters.getPaths;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    roleStudent() {
      return this.$store.getters.getRoles.find(r => r.name === "student")?._id;
    },
    users() {
      return this.$store.getters.getUsers.filter(u =>
        u.roles.includes(this.roleStudent)
      );
    },
    sessions() {
      return this.$store.getters.getSessions.filter(
        s => s.path === this.path._id
      );
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Evolution", route: "sessions" },
      { title: "Manage Sessions" }
    ]);
  },
  created() {},
  methods: {
    getAvatar(user) {
      let userFull = this.users.find(u => u._id === user);
      if (userFull.avatar) {
        return process.env.VUE_APP_API_URL + userFull.avatar;
      } else {
        return "/media/svg/avatars/001-boy.svg";
      }
    },
    async createSessions(p, evt) {
      this.points = [];
      await this.profiles.forEach(profile => {
        this.points.push({ profile: profile._id, points: 0 });
      });
      evt.preventDefault();
      await this.users.forEach(async student => {
        await axios.post("sessions", {
          path: p._id,
          user: student._id,
          points: this.points
        });
      });
      await this.$store.dispatch("fetchSessions");
    },
    deleteItem(id) {
      axios.delete("sessions/" + id).then(response => {
        console.log(response);
        // this.path.paths.splice(
        //   this.path.sections.findIndex(o => o._id == id),
        //   1
        // );
      });
    },
    viewItem(path) {
      this.path = path;

      console.log("click a path", this.sessions);
    },
    updateComment(i) {
      console.log("update comment");
      i.dateModified = new Date();
      axios
        .put("/sessions/" + i._id, {
          description: i.description,
          dateModified: i.dateModified
        })
        .then(response => {
          console.log(response);
        });
    },
    updateTraining(session) {
      console.log("update training");
      axios
        .put("/sessions/" + session._id, {
          training: !session.training
        })
        .then(response => {
          console.log(response);
          this.$store.dispatch("fetchSessions");
        });
    },
    updateAssistance(session) {
      console.log("update training");
      console.log("Asistencia");

      axios
        .put("/sessions/" + session._id, {
          assistance: !session.assistance
        })
        .then(response => {
          this.$store.dispatch("fetchSessions");
          console.log(response);
        });

      console.log("UPDATEAssistance", session.user);
    },
    updatePoints(session) {
      axios
        .put("/sessions/" + session._id, {
          points: session.points
        })
        .then(response => {
          console.log(response);
          this.$store.dispatch("fetchSessions");
        });
    },

    getInitials(u) {
      if (!u.firstName || !u.lastName) {
        return u.userName[0] + u.userName[1];
      } else {
        return u.firstName[0] + u.lastName[0];
      }
    },
    getInitial(u) {
      var res = "";
      for (let i = 0; i < u.split(" ").length; i++) {
        res =
          res +
          u.split(" ")[i].charAt(0) +
          u.split(" ")[i].charAt(1) +
          u.split(" ")[i].charAt(2) +
          " ";
      }
      return res;
    },
    filteredSessions(row, filter) {
      console.log("filtre", row, filter);
      if (filter.student) {
        if (this.users.find(u => u._id === row.user)._id == filter.student) {
          return true;
        } else {
          return false;
        }
      } else if (filter.group) {
        if (this.users.find(u => u._id === row.user).group == filter.group) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
